import Router from 'next/router';
import { NavigationReason } from '@spotify-internal/ubi-types-js';
import { ubiLogger } from './ubiLogger';
import { getPageId } from './getPageId';

function shouldIgnore() {
  return (
    // ignore if router not ready
    !Router.isReady ||
    // ignore index route since index route will always redirect to /home or /c
    Router.pathname === '/'
  );
}

function logNavigation() {
  if (shouldIgnore()) {
    return;
  }

  ubiLogger.logNavigation(
    {
      navigationalRoot: 'mrkt/frontdoor',
      navigationReason: NavigationReason.UNKNOWN,
    },
    {
      pageId: getPageId(Router.asPath),
      entityUri: window.location.href,
    },
  );
}

Router.ready(() => {
  // log initial navigation
  logNavigation();

  // log navigation for every route change
  Router.events.on('routeChangeComplete', logNavigation);
});
